export const QUESTIONS_TYPE = {
  DEFAULT: 'question',
  RATE: 'rate',
  SCORE_RATE: 'score-rate',
  DARK: 'dark',
  EFFECTIVE_EXERCISES: 'effective-exercises',
  KEGEL_BENEFITS: 'kegel-plan-benefits',
  KEGEL_EFFECTIVENESS: 'kegel-effectiveness',
  GOALS: 'goals',
  GOALS_REVIEWS: 'pp1',
  s1: 's1',
  PERSONAL_PLAN: 'personal-plan',
  INTERMEDIATE: 'intermediate',
};
